export default "__VITE_ASSET__9f6e5a8c__"